'use strict';

angular.module('licensure.services')
    .factory('ProcessLicenses', ['$http', '$q', function ($http, $q) {
        return {
            get: function (license_id) {
                var d = $q.defer();

                $http
                    .get(apiLocation + '/api/processlicenses', {
                        params: {
                            license_id: license_id
                        }
                    })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        console.log(response.data);
                        // handle error
                    });

                return d.promise;
            },

            save: function (process_license) {
                var d = $q.defer();

                var method = 'POST';
                var url = apiLocation + '/api/processlicenses/';
                if (!isUndefined(process_license.id)) {
                    method = 'PUT'
                    url += process_license.id
                }

                $http({
                    method: method,
                    url: url,
                    data: {
                        process_license: process_license,
                        process_statuses: process_license.process_statuses
                    }
                })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        // handle error
                    });

                return d.promise;
            },

            delete: function (id) {
                var d = $q.defer();

                $http
                    .delete(apiLocation + '/api/processlicenses/' + id, {
                        params: {

                        }
                    })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        // handle error
                    });

                return d.promise;
            }
        }
    }])
;